import { render, staticRenderFns } from "./Restoration1_1.vue?vue&type=template&id=0dd18108&scoped=true"
import script from "./Restoration1_1.vue?vue&type=script&lang=js"
export * from "./Restoration1_1.vue?vue&type=script&lang=js"
import style0 from "./Restoration1_1.vue?vue&type=style&index=0&id=0dd18108&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd18108",
  null
  
)

export default component.exports